<template>
  <div>
    <h1>Novo de Tipo de Instituição</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("tipos_instituicoes", ["tipo_instituicao"]),
  },
  methods: {
    ...mapActions("tipos_instituicoes", ["ActionNewTipo_instituicao"]),
    loadData(id) {
      this.$router.push({
        name: "tipos_instituicoes_edit",
        params: { id: id },
      });
    },
  },
  async created() {
    this.ActionNewTipo_instituicao();
  },
};
</script>

<style></style>
